"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyElevationDisplay = void 0;

var _clsx = _interopRequireDefault(require("clsx"));

var _react = require("react");

var _box = require("../utils/box");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classes = {
  "root": "sty-elevation-display-module__root___3eZOr"
};

var StyElevationDisplay = function StyElevationDisplay(_ref) {
  var className = _ref.className,
      cssVarName = _ref.cssVarName,
      label = _ref.label,
      boxShadow = _ref.boxShadow;
  var style = (0, _react.useMemo)(function () {
    if (boxShadow) {
      return {
        '--sty-elevation-display--elevation': boxShadow
      };
    }

    if (cssVarName) {
      return {
        '--sty-elevation-display--elevation': "var(".concat(cssVarName, ")")
      };
    }

    return {};
  }, [cssVarName, boxShadow]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_box.StyBox, {
    style: style,
    className: (0, _clsx.default)(className, classes.root),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: label
    }), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)("code", {
      children: boxShadow !== null && boxShadow !== void 0 ? boxShadow : cssVarName
    })]
  });
};

exports.StyElevationDisplay = StyElevationDisplay;